import * as React from "react"
import { AgencyClientProduct, StartWeekDay } from "../../../../../models/agency"
import { Reducer, useReducer } from "react"

export enum EditProductStateActionType {
  GENERIC_CHANGE,
  START_WEEK_DAY,
}

type EditProductStateAction =
  | {
      type: EditProductStateActionType.GENERIC_CHANGE
      payload: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
    }
  | { type: EditProductStateActionType.START_WEEK_DAY; payload: StartWeekDay }

function reducer(state: AgencyClientProduct, action: EditProductStateAction) {
  if (action.type === EditProductStateActionType.GENERIC_CHANGE) {
    const { name, value } = action.payload.target
    return {
      ...state,
      [name]: value,
    }
  }
  if (action.type === EditProductStateActionType.START_WEEK_DAY) {
    return {
      ...state,
      startWeekDay: action.payload,
    }
  }

  throw new Error("Action  not recognized!")
}

export default function useEditProductsReducer(
  initialState: AgencyClientProduct,
) {
  return useReducer<Reducer<AgencyClientProduct, EditProductStateAction>>(
    reducer,
    initialState,
  )
}
